import { useMemo } from "react";

import { useTheme } from "@mui/material/styles";

import { getImageSizes, ImageSizes } from "~/utils/image/image-sizes";

/** Rendered image widths (`sizes` attributes) for every layout, derived from the active theme. */
export const useImageSizes = (): ImageSizes => {
  const theme = useTheme();

  return useMemo(() => getImageSizes(theme), [theme]);
};
